import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';

import { MercadoSituacaoBadgeComponent } from './badge';
import { MercadoSituacaoPipe, MercadoSituacaoFilterPipe } from './pipes';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        MercadoSituacaoBadgeComponent,
        // Pipes
        MercadoSituacaoPipe,
        MercadoSituacaoFilterPipe
    ],
    exports: [
        MercadoSituacaoBadgeComponent,
        // Pipes
        MercadoSituacaoPipe,
        MercadoSituacaoFilterPipe
    ],
    providers: [
        // Pipes
        MercadoSituacaoPipe,
        MercadoSituacaoFilterPipe
    ]
})
export class MercadoSituacaoModule { }
